import BigNumber from "bignumber.js";
const increaseGasPrice = (wei) => {
    const res = wei.plus(new BigNumber(1000000000));
    return res;
};
export { increaseGasPrice, };
//# sourceMappingURL=utils.js.map